var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimationAndMotion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f79f323e-fb5a-4faa-88be-89dd16c99405",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .b96230e8-8d54-400a-9818-7d9eba6c91b1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b96230e8-8d54-400a-9818-7d9eba6c91b1",
    d: "M57.006,10.531H42.994L48.5,16.038V47.969a1.5,1.5,0,0,0,3,0V16.038Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "b96230e8-8d54-400a-9818-7d9eba6c91b1",
    x: 41.413,
    y: 20.376,
    width: 5.395,
    height: 10.239
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b96230e8-8d54-400a-9818-7d9eba6c91b1",
    x: 53.193,
    y: 20.376,
    width: 17.028,
    height: 10.239
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "b96230e8-8d54-400a-9818-7d9eba6c91b1",
    x: 29.779,
    y: 33.452,
    width: 17.028,
    height: 10.239
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b96230e8-8d54-400a-9818-7d9eba6c91b1",
    x: 53.193,
    y: 33.452,
    width: 5.394,
    height: 10.239
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimationAndMotion);
export default __webpack_public_path__ + "static/media/AnimationAndMotion.01dc4014777c0468a53ea860ada4e541.svg";
export { ForwardRef as ReactComponent };